// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ojBjN","fit":"Card_fit__y+tZW","content":"Card_content__ziOYB","dimmed":"Card_dimmed__m-pc5","loading":"Card_loading__pjlE1","visible":"Card_visible__4+do6"};